import React, { useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import MieszkaniecDaneWodaRozliczenieWydrukA4 from "./MieszkaniecDaneWodaRozliczenieWydrukA4.js";

const MieszkaniecDaneWodaRozliczenieWydrukModal = props => {
    
    const { setShowPrint, rozliczenieWodyAkt, procent, odczyty, mieszkaniec, adres } = props;

    const componentRef = useRef();

    const handleShowPrint = () => setShowPrint(prevState => !prevState);
    
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Visitor Pass',
        onAfterPrint: () => console.log('Printed PDF successfully!'),
    });

    return (
        <div 
            className='rozliczenieWydruk'
            onClick={handleShowPrint}
        >
            <div className='modal'>
                <div>
                    <button
                        onClick={handlePrint}
                    >
                        Drukuj
                    </button>
                </div>
                <MieszkaniecDaneWodaRozliczenieWydrukA4
                    componentRef={componentRef} 
                    setShowPrint={setShowPrint}
                    rozliczenieWodyAkt={rozliczenieWodyAkt}
                    procent={procent}
                    odczyty={odczyty}
                    mieszkaniec={mieszkaniec}
                    adres={adres}
                />
            </div>
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukModal;